import { render, staticRenderFns } from "./newBusiForm.vue?vue&type=template&id=79dd1d54&scoped=true"
import script from "./newBusiForm.vue?vue&type=script&lang=js"
export * from "./newBusiForm.vue?vue&type=script&lang=js"
import style0 from "./newBusiForm.vue?vue&type=style&index=0&id=79dd1d54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dd1d54",
  null
  
)

export default component.exports